import { ENCRYPTED_KEY_BASE64_MAX_SIZE, ENCRYPTED_KEY_BASE64_MIN_SIZE, } from '../constants';
import { stringValidator } from './string';
export const encryptedKeyByRsaKeyValidator = stringValidator({
    requiredError: 'internal.key.required',
    minLength: {
        min: ENCRYPTED_KEY_BASE64_MIN_SIZE,
        error: 'internal.key.minLength',
    },
    maxLength: {
        max: ENCRYPTED_KEY_BASE64_MAX_SIZE,
        error: 'internal.key.maxLength',
    },
});
